import { useIntl } from 'react-intl';

import { Button } from '@/components/Button';
import { Col } from '@/components/Col';
import type { ModalProps } from '@/components/Modal';
import { Modal } from '@/components/Modal';
import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';
import { serviceMessages } from '@/messages/service';

import * as S from './RepairOrderNotFoundModal.styles';

export type RepairOrderNotFoundModalProps = ModalProps & {
  onHeaderClose?: () => void;
};
export const RepairOrderNotFoundModal = ({
  onHeaderClose,
  ...props
}: RepairOrderNotFoundModalProps) => {
  const { formatMessage } = useIntl();
  return (
    <Modal {...props}>
      <Modal.Header divider onClose={onHeaderClose}>
        <SectionHeader
          numberOfColoredWords={2}
          sizeDesktop={40}
          sizeMobile={34}
          text={formatMessage(serviceMessages.repairOrderNotFound)}
          textAlign='center'
        />
      </Modal.Header>
      <Modal.Body>
        <S.Empty
          alignItems='center'
          flexDirection='column'
          gridGap={1}
          maxWidth='537px'
          py={1}
        >
          <Typography scale='h2' textAlign='center' textTransform='uppercase'>
            {formatMessage(serviceMessages.incorrectEmailAndRepairNumber)}
          </Typography>
          <Typography textAlign='center'>
            {formatMessage(serviceMessages.incorrectEmailAndRepairNumberTip)}
          </Typography>
          <S.Wrapper gapDensity='none' mt={2}>
            <Col sm={4} smStart={5} xs={12}>
              <Button isFullWidth onClick={props.onClose} variant='outlined'>
                {formatMessage(serviceMessages.back)}
              </Button>
            </Col>
          </S.Wrapper>
        </S.Empty>
      </Modal.Body>
    </Modal>
  );
};
